import type { Sprint } from '../../model/index.tsx';
import getActiveSprints from '../../rest/get-active-sprints/index.tsx';

const getActiveSprints1 = async (boardId: string): Promise<Sprint[]> => {
	const activeSprints = await getActiveSprints(boardId);
	return activeSprints.values;
};

export default getActiveSprints1;
